module.exports = __webpack_public_path__ + "img/new-ab.2783f24d.jpg";